module.exports = ['$scope', 'playlistLoader', 'MyPlaylistModal', 'PlaylistShareModal', 'Confirm', 'PlaylistItems', '$rootScope', 'growl',
    function PlaylistsCtrl($scope, playlistLoader, MyPlaylistModal, PlaylistShareModal, Confirm, PlaylistItems, $rootScope, growl) {
        "use strict";
        $scope.playlistsLoader = playlistLoader;

        $scope.enableSort = false;
        $scope.toggleSort = function() {
            $scope.enableSort = !$scope.enableSort;
            if (!$scope.enableSort) {
                $scope.$broadcast('PLAYLIST_REORDERED');
            }
        };

        $scope.new = function () {
            MyPlaylistModal.open({
                success: function () {
                    $scope.playlistsLoader.getFirstPage();
                }
            });
        };

        /**
         * @param {Object} playlist
         */
        $scope.edit = function (playlist) {
            MyPlaylistModal.open({
                success: function (args) {
                    angular.copy(args[1], playlist);
                }
            }, {
                playlist: angular.copy(playlist)
            });
        };

        /**
         * @param {Object} playlist
         */
        $scope.delete = function (playlist, message) {
            Confirm.prompt(function () {
                playlist.$delete(
                    function () {
                        var index = $scope.playlistsLoader.data.indexOf(playlist);
                        $scope.playlistsLoader.data.splice(index, 1);
                    }, function (r) {
                        if (r.data.errors) {
                            angular.forEach(r.data.errors, function (e) {
                                growl.error(e.message);
                            });
                        }
                    }
                );
            }, message);
        };

        /**
         * @param  {Object} playlist
         */
        $scope.copy = function (playlist) {
            playlist.$copy(function () {
                $scope.playlistsLoader.getFirstPage();
            });
        };

        /**
         * @param  {Object} playlist
         */
        $scope.share = function (playlist) {
            PlaylistShareModal.open(undefined, {
                playlist: playlist
            });
        };

        /**
         * Notifies child controllers to delete all selected
         * @param {String} message
         */
        $scope.deleteSelection = function (message) {
            Confirm.prompt(function () {
                $scope.$broadcast('playlist.deleteselected');
            }, message);
        };

        /**
         * @param {Object} subject
         * @todo use a event to decouple this from playlistbundle (Mark Cremer)
         */
        $scope.download = function (playlist) {
            PlaylistItems.query({
                'playlistId': playlist.id
            }, function (subjects) {
                $rootScope.$emit('MEDIA_DOWNLOAD', subjects, {
                    filename: playlist.name,
                    origin: 2
                });
            });
        };

        $scope.sort = function (playlist, sortField, sortOrder, message) {
            Confirm.prompt(function () {
                playlist.$sort({
                    sortField: sortField,
                    sortOrder: sortOrder
                }, function (r) {
                    $scope.$broadcast('PLAYLIST_REORDERED');
                }, function (r) {
                    //todo
                });
            }, message);
        };

        /**
         * listen to changes in selection in the child scope
         * it would be nice to simple react to an event and reload the data,
         * but doign this causes the playlist tab to be closed
         */
        $scope.$on('PLAYLISTITEMS_REMOVEFROMPLAYLIST', function (event, playlist, count) {
            playlist.count = count;
        });
    }];




// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/controllers/PlaylistsCtrl.js